import {
  useCurrentTill,
  type TillQueryData
} from "~/api/tills/hooks/use-till-current/use-till-current";

const selectShowPricesInclVat = (till: TillQueryData) => till.showPricesInclVat;

/**
 * The till's "Show prices incl. VAT" setting, from the current-till query.
 * Falls back to incl VAT while the till is unresolved: showing a price with
 * the tax included is the safe direction in every market.
 */
export const useShowPricesInclVat = (): boolean =>
  useCurrentTill(selectShowPricesInclVat).data ?? true;
